import type { PublicStorefrontSettings } from "@modules/global-shell/types"

export type CompanyLegalDetails = Pick<PublicStorefrontSettings["footer"],
  "company_name" | "company_address" | "tax_office" | "tax_number"
>

const compactWhitespace = (value: string) => value.trim().replace(/\s+/g, " ")

export function composeCompanyLegalCopy(footer: CompanyLegalDetails) {
  const companyName = compactWhitespace(footer.company_name)
  const address = compactWhitespace(footer.company_address)
  const taxOffice = compactWhitespace(footer.tax_office)
  const taxNumber = compactWhitespace(footer.tax_number)
  const identity = [companyName, address].filter(Boolean).join(" ")
  const officeName = taxOffice
    ? taxOffice.toLocaleLowerCase("tr-TR").endsWith("vergi dairesi")
      ? taxOffice
      : `${taxOffice} Vergi Dairesi`
    : ""

  const taxStatement = taxNumber && officeName
    ? `${taxNumber} vergi numarasıyla ${officeName}'ne bağlıdır.`
    : taxNumber
      ? `Vergi numarası: ${taxNumber}.`
      : officeName
        ? `${officeName}'ne bağlıdır.`
        : ""

  return { companyName, address, identity, taxStatement }
}
